import 'react-app-polyfill/stable';
// Initializing locale data for 'en' and 'de'
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/de'; // Add locale data for de
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/de'; // Add locale data for de

// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { Auth } from './Auth';
import routes from './routes';

const router = createBrowserRouter([
  {
    element: <Auth />,
    //errorElement: <Page404 />,
    children: routes,
  },
]);

createRoot(document.getElementById('root')).render(<RouterProvider router={router} />);
